import withStyles from "isomorphic-style-loader/withStyles";
import { Row, Col } from "reactstrap";
import s from "./styles.scss";
import React from "react";

interface IMetricField {
  label: string;
  total: string;
}

interface Props {
  hideSelection: () => void;
  title: string;
  date?: string;
  fields: Array<IMetricField>;
  format?: (number) => string;
}

const getBubbleContent = (
  fields: Array<IMetricField>,
  format?: (number) => string
) => {
  let renderValue = [];
  const classArray = [null, s.bigBubble, s.bubble, s.smallBubble];
  fields.forEach((field, index) => {
    const total = format ? format(field.total) : field.total;
    renderValue.push(
      <div className={classArray[fields.length]} key={`bubble+${index}`}>
        <div className={s.bubbleText}>{total}</div>
        <div className={s.bubbleSmallLabel}>{field.label}</div>
      </div>
    );
  });
  return renderValue;
};

function MetricsBubble(props: Props) {
  const { title, date, fields } = props;
  return (
    <main className={s.main}>
      <div className={s.container}>
        <Row>
          <Col xs={8} className={s.bubbleLabel}>
            {title}
          </Col>
          <Col xs={4} className={s.smallLabel}>
            {date}
          </Col>
        </Row>
        <Row>
          <Col xs={12} className={s.displayFlex}>
            {getBubbleContent(fields, props.format)}
          </Col>
        </Row>
      </div>
    </main>
  );
}

export default withStyles(s)(MetricsBubble);
